<template src="@/templates/appHeader/appHeader.html"></template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState(["sideNav", "profile"]),
    ...mapGetters(["isAuthenticated", "full_name", "interpreterId", "jwt"]),
  },
  methods: {
    ...mapActions(["toggleSideNav", "updateBackButton", "updateScrollStatus"]),
    gotoHome() {
      console.log("sds");
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style scoped>
#appNav {
  background-color: #4e5661;
  z-index: 1 !important;
  color: #fff;
  position: fixed;
  width: 100%;
  top: 0;
}
</style>
